export * from './monitoring';
export { WEB_TEAM_BUGSNAG_CLIENT_API_KEY } from './logging/bugsnag/bugsnag-client';
export { StartTimer, TimerFunction } from './services/timeMeasuring';
export { default as logger, init as initLogger, BugsnagLoggerOptions } from './logging';
export { default as queryString } from './queryString';
export { default as userAgentParser } from './UserAgentParser';
export { enhanceErrorReports, initializeBugsnag, EnhancingData } from './logging/bugsnag/client-enhancing';
export { default as ErrorBoundaryCreator } from './logging/bugsnag/ErrorBoundary';
export { default as HttpError } from './errors/HttpError';
export { default as SensitiveDataRedactor } from './logging/bugsnag/SensitiveDataRedactor';
export * from './analytics/hoc';
export { performanceTimeline } from './services/performanceTimeline';
export { ToProp, FromObservable, withPropFromObservable } from './HOCs/withPropFromObservable';



// WEBPACK FOOTER //
// ./packages/platform-utils/index.ts